import { initialStateCompanyInfo } from '../../../../../hooks/companyInfo';
import ConfigProjectLayout from '../../../../../theme/templates/project/config';
import ViewProjectPage from '../view';

const NewProjectPage = () => {
  initialStateCompanyInfo();

  return (
    <ConfigProjectLayout>
      <ViewProjectPage />
    </ConfigProjectLayout>
  )
}

export default NewProjectPage;
